// ##### Komarov 2025-07-12
import { useEffect, useState } from 'react';
// ##### Komarov 2025-07-25
import { isServer } from '../../../../server/helpers/browserDetector';

export const useWindowWidthAndHeight = () => {
  // 1- Получаем размер окна
  // ##### 24-03-21 Komarov
  const getWindowInnerSize = () => {
    if (!isServer) {
      return [window.innerWidth, window.innerHeight];
    }
    return [0, 0];
  };

  // 2- Define the state variable windowSize and pass windowInnerSize as its initial value
  // ##### 24-03-21 Komarov
  const [windowSize, setWindowSize] = useState(getWindowInnerSize);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (isServer) return;
    const changeWindowSize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener('resize', changeWindowSize);
    // 4- cleanup the 'resize' eventListener
    return () => window.removeEventListener('resize', changeWindowSize);
  }, []);
  // 5- return the window size
  return windowSize;
};
